import Img from 'gatsby-image'

import React from 'react'

export default function OptimizedImage({
  image,
  defaultImage,
  type = 'sizes',
  ...other
}) {
  if (!image) {
    return <img src={defaultImage} alt="" {...other} />
  }
  const props = { [type]: image.childImageSharp[type] }
  return <Img {...props} {...other} backgroundColor="#CCCCCC" />
}



// WEBPACK FOOTER //
// ./src/components/OptimizedImage.js